import{gql as e}from"@apollo/client";import"../../graphql/fragments/geladaOrganisation.fragment.js";import"../../graphql/fragments/geladaProject.fragment.js";import"../../graphql/fragments/groupCreationRequest.fragment.js";import{LOGIN_FRAGMENT as o}from"../../graphql/fragments/login.fragment.js";import"../../graphql/fragments/projectSettings.fragment.js";import"../../graphql/fragments/projectTheme.fragment.js";import"../../graphql/fragments/user.fragment.js";const r=e`
  query login(
    $login: String
    $mfaCode: String
    $password: String!
    $phoneNumber: String
    $shouldIncludeOrganisationLogo: Boolean = false
    $shouldIncludeProjectDomain: Boolean = false
    $shouldIncludeProjectLogo: Boolean = false
    $shouldIncludeProjectSettings: Boolean = false
    $shouldIncludeProjectTheme: Boolean = false
    $shouldIncludeUserAvatar: Boolean = false
    $shouldIncludeUserCredential: Boolean = true
    $shouldIncludeUserCustomFields: Boolean = false
    $shouldIncludeUserMembershipsGroup: Boolean = true
    $shouldIncludeUserMembershipsProject: Boolean = true
    $shouldIncludeUserMembershipsUnit: Boolean = false
    $shouldIncludeUserMembershipsUserType: Boolean = false
    $shouldIncludeUserPictures: Boolean = false
    $shouldIncludeUserMemberships: Boolean = false
  ) {
    login(login: $login, password: $password, phoneNumber: $phoneNumber, mfaCode: $mfaCode) {
      ...loginFragment
    }
  }

  ${o}
`;export{r as LOGIN_QUERY};
//# sourceMappingURL=useLogin.graphql.js.map
